<script lang="ts">
    import LoadingScreen from '$lib/components/LoadingScreen.svelte';
    import PageWrapper from '$lib/components/_page/PageWrapper.svelte';

    export let setup: Promise<void>
</script>

{#await setup}
    <LoadingScreen/>
{:then _ }
    <slot/>
{:catch _}
    <PageWrapper footer={true}>
        <h1>Oops!</h1>
        <p>
            Something went wrong. Please try again or contact support@vocabeo.com if the problem persists.
        </p>
    </PageWrapper>
{/await}